














































































































































































import { rollCallListData, rollCallList } from "@/api/teacherManage";
import { getSelectClassList, getSelectCourseList } from "@/api/globalSearch";
import rollcallDetailsDialog from "./rollcallDetailDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import { Component, Prop, Vue } from "vue-property-decorator";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    rollcallDetailsDialog,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {};
  searchCourseList: any[] = [];
  searchClassList: any[] = [];
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 20;
  pageSizeArray: number[] = [20, 50, 100];
  total: number = 0;
  mounted() {
    this.getClassLog({
      page: 1,
      page_size: this.pageSize,
    });
    this.handleSearchCourse();
    this.handleSearchClass();
  }
  handleSearchClass(v?: any) {
    getSelectClassList({
      page: 1,
      page_size: 50,
      name: v,
    }).then((res: any) => {
      this.searchClassList = res.data.list;
    });
  }
  handleSearchCourse(v?: any) {
    getSelectCourseList({
      page: 1,
      page_size: 100,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.searchCourseList = res.data.list;
      }
    });
  }
  handleSearch() {
    this.getClassLog({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getClassLog(data: rollCallListData) {
    data.teacher_id = Number(this.$route.query.id);
    data.status = 1;
    if (this.searchInfo.class_id) {
      data.class_id = this.searchInfo.class_id;
    }
    if (this.searchInfo.course_id) {
      data.course_id = this.searchInfo.course_id;
    }
    if (this.searchInfo.staff_id) {
      data.staff_id = this.searchInfo.staff_id;
    }
    if (
      this.searchInfo.rollcallTime &&
      this.searchInfo.rollcallTime.length === 2
    ) {
      data.roll_call_start_date = this.searchInfo.rollcallTime[0];
      data.roll_call_end_date = this.searchInfo.rollcallTime[1];
    }
    if (this.searchInfo.lessonTime && this.searchInfo.lessonTime.length === 2) {
      data.lesson_start_date = this.searchInfo.lessonTime[0];
      data.lesson_end_date = this.searchInfo.lessonTime[1];
    }
    rollCallList(data).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.list != null) {
          res.data.list.map((a: any) => {
            a.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(Number(a.create_time + "000"))
            );
          });
        }
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = res.data.page;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getClassLog({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getClassLog({
      page: 1,
      page_size: e,
    });
  }
  toRollcallDetail(row: any) {
    this.$router.push({
      name: "rollCallDetails",
      query: { id: row.roll_call_id },
    });
  }
}
